export default class ComponentRegistration {
    constructor(public name: string,
        public registration: ng.IComponentOptions) {
    }
} 


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/component-registration.ts